import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftonenoteComponent } from './simple-icons-microsoftonenote.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftonenoteComponent ],
    exports:      [ SimpleIconsMicrosoftonenoteComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftonenoteModule {}
